export { UpsellCard, type UpsellCardProps } from './upsellCard';
